/** Partner portals are scoped under each Client View: /v/:slug/partner/... */
export const CASAMAPA_CLIENT_VIEW_SLUG = "casamapa";
export const CASAMAPA_PARTNER_PORTAL_BASE = `/v/${CASAMAPA_CLIENT_VIEW_SLUG}/partner`;
/** @deprecated Temp admin2 path — redirects to partner. */
export const CASAMAPA_ADMIN2_PORTAL_BASE = `/v/${CASAMAPA_CLIENT_VIEW_SLUG}/admin2`;

export function clientViewPartnerPortalBase(slug) {
  if (!slug) {
    return null;
  }

  return `/v/${slug}/partner`;
}

export function clientViewPartnerPortalPath(slug, segment = "") {
  const base = clientViewPartnerPortalBase(slug);
  if (!base) {
    return null;
  }

  const normalized = String(segment || "").replace(/^\/+/, "");
  return normalized ? `${base}/${normalized}` : base;
}

export function casamapaPartnerPortalPath(segment = "") {
  return clientViewPartnerPortalPath(CASAMAPA_CLIENT_VIEW_SLUG, segment);
}
